import { ChangeDetectionStrategy, Component } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-iframe-not-foundpage',
  imports: [FormsModule],
  templateUrl: './iframeNotFoundpage.component.html',
  styleUrl: './iframeNotFoundpage.component.scss',
  animations: [
    trigger('slideIn', [
      state('hidden', style({
        right: '-100px',
        transform: 'rotate(360deg)',
        opacity: 0
      })),
      state('visible', style({
        right: '15px',
        transform: 'rotate(0deg)',
        opacity: 1
      })),
      transition('hidden => visible', animate('500ms 4500ms ease-out'))
    ])
  ]
})
export class IframeNotFoundpageComponent {
  errorContent: string[] = [];
  fullContent = [
    `&gt; <span class='tw-text-[#f0c674]'>ERROR CODE</span>: "<i class='tw-text-[#8abeb7]'>HTTP 403 Forbidden</i>"`,
    `&gt; <span class='tw-text-[#f0c674]'>ERROR DESCRIPTION</span>: "<i class='tw-text-[#8abeb7]'>Access Denied. You Do Not Have The Permission To Access This Page On This Server</i>"`,
    `&gt; <span class='tw-text-[#f0c674]'>ERROR POSSIBLY CAUSED BY</span>: [<b class='tw-text-[#81a2be]'>execute access Forbidden, read access Forbidden, write access Forbidden, ssl required, ssl 128 required, ip address rejected, client certificate required, site access denied, too many users, invalid configuration, password change, mapper denied access, client certificate revoked, directory listing denied, client access licenses exceeded, client certificate is untrusted or invalid, client certificate has expired or is not yet valid, passport logon failed, source access denied, infinite depth is denied, too many requests from the same client ip</b>...]`
  ];
  ngOnInit() {
    this.errorContent.push('');
    this.typeLine(this.fullContent[0], 0);
  }
  private typeLine(line: string, index: number): void {
    let charIndex = 0;
    const interval = setInterval(() => {
      if (!this.errorContent[index]) this.errorContent[index] = '';
      this.errorContent[index] += line[charIndex];
      charIndex++;
      if (charIndex >= line.length) {
        clearInterval(interval);
        if (index + 1 < this.fullContent.length) {
          this.errorContent.push('');
          this.typeLine(this.fullContent[index + 1], index + 1);
        }
      }
    }, 10); // Simulate typewriter speed
  }
}
